import { extractProps } from "@radix-ui/themes/helpers";
import { marginPropDefs, type MarginProps } from "@radix-ui/themes/props";
import clsx from "clsx";
import * as React from "react";
import type { IdentityProvider } from "./identity-providers.js";
import type { DataIntegration } from "../api/endpoint.js";

interface ProviderIconProps
  extends React.ComponentPropsWithRef<"div">, MarginProps {
  provider: IdentityProvider | DataIntegration["integrationType"];
  size?: "1" | "2" | "3" | "4";
}

const ProviderIcon = React.forwardRef<HTMLDivElement, ProviderIconProps>(
  (props, forwardedRef) => {
    const {
      provider,
      size = "4",
      className,
      ...providerIconProps
    } = extractProps(props, marginPropDefs);

    return (
      <div
        {...providerIconProps}
        ref={forwardedRef}
        className={clsx("woswidgets-provider-icon", `size-${size}`, className)}
        data-provider={provider}
      />
    );
  },
);

ProviderIcon.displayName = "ProviderIcon";

export { ProviderIcon };
